module.exports = __webpack_public_path__ + "static/media/6.cec3b55b.jpg";